<script setup>
import { ref, computed, onMounted, getCurrentInstance, watch } from 'vue'
import {useRoute, useRouter} from 'vue-router'
import _ from 'lodash'
import { usePageLoadingStore } from "../../../../../stores/pageLoading";
import { useUserStore } from "../../../stores/user";
import SNB from '../../../../../layouts/nav/SNB.vue'
import KSAInputNumber from "../../../../../components/ui-components/input/KSAInputNumber.vue";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import jobFairCorpService from "@/pages/user/services/jobFair/jobFairCorpService";
import { useAlertStore } from '../../../../../stores/alertStore';
const { $alert, $confirm } = useAlertStore();

const route = useRoute();
const router = useRouter()
const globals = getCurrentInstance().appContext.config.globalProperties;
const { $toast, $gb } = globals;
const loadingStore = usePageLoadingStore()
const userStore = useUserStore()
const isStudent = ref(true);
const schoolGbRef = ref(null); // 학력
const workAreaRef = ref(null); // 근무지역
const salaryGbRef = ref(null); // 급여
const editorRef = ref(null); // 기타 요건

const jobNoticeSeq = ref(route.query.jobNoticeSeq || '');
const resumeId = ref(route.query.resumeId || '');
const inteYn = ref(route.query.inteYn || '');
const mode = ref(route.query.mode || '');

const tabList = ref([
  { title: '기본 정보', active: true, completed: false, closed: false },
  { title: '소개', active: false, completed: false, closed: false },
  { title: '학력', active: false, completed: false, closed: false },
  { title: '포트폴리오', active: false, completed: false, closed: false },
  { title: '자격증 및 외국어', active: false, completed: false, closed: false },
  { title: '업무 경험', active: false, completed: false, closed: false },
  { title: '병역', active: false, completed: false, closed: false },
])

const saveIsDisabled = ref(false)

onMounted(()=> {
  ojfCropJobNoticeDetail();

  if(userStore.user.userGb !== '01' && userStore.user.userGb !== 'STUDENT') {
    isStudent.value = false;
  }

  _.each(data_interests.value, el => {el.on = false;})
  _.each(data_job.value, el => {el.on = false;})


  // 저장 비활성화
  //saveIsDisabled.value = Number(moment().format('YYYYMMDD')) >= 20230527;
})

const currentTabIndex = computed(()=>{
  return _.findIndex(tabList.value, {'active': true});
})


const jobNoticeDetail = ref({
  "jobNoticeSeq": 0,
  "jobName": '', // 채용공고명
  "interests": '', // 관심카테고리
  "job": '', // 직무
  "recruitArea": '', // 모집분야명
  "recruitCnt": 0, // 모집인원
  "jobExperience": '', //  경력
  "schoolGb": '', // 학력 05 고졸 01 대학(2,3년) 02 대학(4년) 03 대학원(석사) 04 대학원(박사)
  "specialTreat": '', // 우대사항(자격증)
  "workArea1": '', // 근무지역_시도
  "workArea2": '', // 근무지역_시군구
  "workHomeYn": 'N', // 재택가능여부
  "workType": '', // 근무형태
  "salaryGb": '01', // 급여구분
  "salary": 0, // 급여
  "note": '<strong>[전형단계]</strong><br>' +
      '<span style="color:hsl(0, 0%, 70%);">예시)</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">①지원서 접수</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">②서류전형</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">③1차면접</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">④2차면접</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">⑤채용검진</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">⑥최종합격</span><br>' +
      '<br>' +
      '<strong>[기타]</strong><br>' +
      '<span style="color:hsl(0, 0%, 70%);">예시)</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">-최종 합격 후, 회사가 지정하는 입사일에 입사 불가할 경우 합격이 취소되거나 전형상의 불이익이 있을 수 있습니다.</span><br>' +
      '<span style="color:hsl(0, 0%, 70%);">-지원서를 포함하여 채용 전형 진행 중 모든 과정에서 제출한 내용이 사실과 다르거나 문서로 증빙이 불가할 경우 합격이 취소되거나 전형상의 불이익이 있을 수 있습니다.</span><br>'
  , // 기타 요건
})

const inputError = ref({
  jobName: '', // 채용공고명
  interests: '', // 관심카테고리
  job: '', // 직무
  recruitArea: '',// 모집분야명
  recruitCnt: '', // 모집인원
  jobExperience: '', //  경력
  schoolGb: '', // 학력
  specialTreat: '', // 우대사항(자격증)
  workArea: '', // 근무지역
  workHomeYn: '', // 재택가능여부
  workType: '', // 근무형태
  salary: '', // 급여구분
})

const data_interests = ref(globals.$interests) // 관심 카테고리
const data_job = ref(globals.$desiredJob) // 직무
const data_jobExperience = ref(globals.$jobExperience) // 경력
const data_workType = ref(globals.$workType) // 근무형태

// 관심 카테고리
const interestCount = computed(()=>{
  return _.filter(data_interests.value, {'on': true}).length || 0;
})

const onClickInterest = (interest) => {
  inputError.value.interests = '';
  if(interest.on) {
    interest.on  = false;
  } else {
    if(interestCount.value < 3) {
      interest.on = true;
    } else {
      inputError.value.interests = '최대 3개까지 선택할 수 있습니다.';
    }
  }
}

// 직무
const onClickJob = (job) => {
  inputError.value.job = '';
  if(job.on) {
    job.on  = false;
  } else {
    job.on = true;
  }
}

// 경력
const onClickJobExperience = (jobExperience) => {
  inputError.value.jobExperience = '';
  if(jobExperience.on) {
    jobExperience.on  = false;
  } else {
    jobExperience.on = true;
  }
}

// 근무지역
const onSelectedWorkArea1 = (option) => {
  jobNoticeDetail.value.workArea1 = option;
  inputError.value.workArea = '';
}

const onSelectedWorkArea2 = (option) => {
  jobNoticeDetail.value.workArea2 = option;
  inputError.value.workArea = '';
}

const onClickWorkHomeYn = (select) => {
  inputError.value.workHomeYn = '';
  if(select === 'Y') {
    jobNoticeDetail.value.workHomeYn = 'N';
  } else {
    jobNoticeDetail.value.workHomeYn = 'Y';
  }
}

// 근무형태
const onClickWorkType = (selectedWorkType) => {
  inputError.value.workType = '';
  data_workType.value.forEach(item => {
    item.on = (item === selectedWorkType);
  });
}

const initSelectGbRefs = () => {
  setTimeout(()=>{
    if (currentTabIndex.value === 2) { // 학력
      for(let i=0; i<schoolGbRefs.value.length; i++) {
        schoolGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<majorGbRefs.value.length; i++) {
        majorGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<submajorTypeGbRefs.value.length; i++) {
        submajorTypeGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<submajorGbRefs.value.length; i++) {
        submajorGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<eduTenureGbRefs.value.length; i++) {
        eduTenureGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<fullScoreGbRefs.value.length; i++) {
        fullScoreGbRefs.value[i].initSelectedOption();
      }
    } else if (currentTabIndex.value === 4) { // 자격증및외국어
      for(let i=0; i<langGbRefs.value.length; i++) {
        langGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<langLevelGbRefs.value.length; i++) {
        langLevelGbRefs.value[i].initSelectedOption();
      }
    }
  }, 100)
}

// 공고 정보
const ojfCropJobNoticeDetail = () => {
  loadingStore.loading = false;

  let paramObj = {
    jobNoticeSeq: jobNoticeSeq.value,
  }
  jobFairCorpService.ojfCropJobNoticeDetail(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          jobNoticeDetail.value = result;

          // 모집 분야
          // 관심 카테고리
          if(result.interests !== null && result.interests !== '') {
            _.each(data_interests.value, el => {
              el.on = result.interests.indexOf(el.label) > -1;
            })
          }
          // 직무
          if(result.job !== null && result.job !== '') {
            _.each(data_job.value, el => {
              el.on = result.job.indexOf(el.label) > -1;
            })
          }
          // 지원 자격 / 근무조건
          // 경력
          if(result.jobExperience !== null && result.jobExperience !== '') {
            _.each(data_jobExperience.value, el => {
              el.on = result.jobExperience.indexOf(el.label) > -1;
            })
          }
          // 학력
          if(result.schoolGb) {
            schoolGbRef.value.initSelectedOption(result.schoolGb);
          }
          // 근무지역
          if(result.workArea1 && result.workArea2) {
            workAreaRef.value.initSelectedOption(result.workArea1, result.workArea2)
          }
          // 근무형태
          if(result.workType !== null && result.workType !== '') {
            _.each(data_workType.value, el => {
              el.on = result.workType.indexOf(el.label) > -1;
            })
          }
          // 급여
          if(result.salaryGb) {
            salaryGbRef.value.initSelectedOption(result.salaryGb);
          }
          // 기타 요건
          if (result.note) {
            setTimeout(() => {
              editorRef.value.init(result.note);
            }, 100)
          }
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}

// 공고 수정
const updateJobNotice = (jobNoticeSeq, ojfId, resumeId, inteYn) => {
  clearErrorFocus();
  let isInvalid = false;

  // 식별자 숫자 검증
  const jobNoticeSeqNum = Number(jobNoticeSeq);
  const ojfIdNum = Number(ojfId);
  if (!Number.isInteger(jobNoticeSeqNum) || jobNoticeSeqNum <= 0) {
    $toast('error', '채용공고 식별자가 올바르지 않습니다.');
    return;
  }
  if (!Number.isInteger(ojfIdNum) || ojfIdNum <= 0) {
    $toast('error', '행사 식별자가 올바르지 않습니다.');
    return;
  }

  // 공고 제목 저장
  const { jobName } = jobNoticeDetail.value;
  inputError.value.jobName = '';

  const jobNameTrim = jobName ? jobName.trim() : '';
  if(!jobNameTrim) {
    inputError.value.jobName = '공고 제목을 입력하세요.';
    isInvalid = true;
  } else if (jobNameTrim.length > 50) {
    inputError.value.jobName = '공고 제목은 최대 50자입니다.';
    isInvalid = true;
  }

  // 모집 분야
  const interests = _.map(_.filter(data_interests.value, {'on': true}), 'value').join(',');
  const job = _.map(_.filter(data_job.value, {'on': true}), 'value').join(',');
  const { recruitArea, recruitCnt } = jobNoticeDetail.value;

  inputError.value.interests = '';
  inputError.value.job = '';
  inputError.value.recruitArea = '';
  inputError.value.recruitCnt = '';

  if(!interests) {
    inputError.value.interests = '관심 카테고리를 선택하세요.';
    isInvalid = true;
  } else if (interests.length > 200) {
    $toast('error', '관심 카테고리가 너무 깁니다.');
    isInvalid = true;
  }

  if(!job) {
    inputError.value.job = '직무를 선택하세요.';
    isInvalid = true;
  } else if (job.length > 200) {
    $toast('error', '직무 선택 값이 너무 깁니다.');
    isInvalid = true;
  }

  const recruitAreaTrim = recruitArea ? recruitArea.trim() : '';
  if (!recruitAreaTrim) {
    inputError.value.recruitArea = '모집분야명을 입력하세요.';
    isInvalid = true;
  } else if (recruitAreaTrim.length > 50) {
    inputError.value.recruitArea = '모집분야명은 최대 50자입니다.';
    isInvalid = true;
  }

  const recruitCntNum = Number(recruitCnt);
  if (!Number.isInteger(recruitCntNum) || recruitCntNum <= 0) {
    inputError.value.recruitCnt = '모집인원은 1명 이상이어야 합니다.';
    isInvalid = true;
  }

  // 지원 자격 / 근무조건
  const jobExperience = _.map(_.filter(data_jobExperience.value, {'on': true}), 'value').join(',');
  const workType = _.map(_.filter(data_workType.value, {'on': true}), 'value').join(',');
  const {schoolGb, specialTreat, workArea1, workArea2, workHomeYn, salaryGb, note } = jobNoticeDetail.value;

  if (!jobExperience) {
    inputError.value.jobExperience = '경력을 선택하세요.';
    isInvalid = true;
  } else if (jobExperience.length > 10) {
    inputError.value.jobExperience = '경력 값은 최대 10자입니다.';
    isInvalid = true;
  }

  if (!schoolGb) {
    inputError.value.schoolGb = '학력을 선택하세요.';
    isInvalid = true;
  } else if (schoolGb.length > 2) {
    inputError.value.schoolGb = '학력 값은 최대 2자입니다.';
    isInvalid = true;
  }

  const specialTreatTrim = specialTreat ? specialTreat.trim() : '';
  if (!specialTreatTrim) {
    inputError.value.specialTreat = '우대 사항을 입력하세요.';
    isInvalid = true;
  } else if (specialTreatTrim.length > 50) {
    inputError.value.specialTreat = '우대 사항은 최대 50자입니다.';
    isInvalid = true;
  }

  const workArea1Trim = workArea1 ? workArea1.trim() : '';
  const workArea2Trim = workArea2 ? workArea2.trim() : '';
  // "시/도 선택" 문구는 빈값으로 처리
  const workArea1Clean = workArea1Trim === '시/도 선택' ? '' : workArea1Trim;
  const workArea2Clean = workArea2Trim === '시/구/군 선택' ? '' : workArea2Trim;
  const area1filter = !workArea1Clean;
  const area2filter = !workArea2Clean;

  if (!workHomeYn || workHomeYn === 'N' && (area1filter || area2filter)) {
    inputError.value.workArea = '근무지역을 선택하세요.';
    isInvalid = true;
  } else {
    inputError.value.workArea = '';
  }

  if (!workType) {
    inputError.value.workType = '근무형태를 선택하세요.';
    isInvalid = true;
  } else if (workType.length > 10) {
    inputError.value.workType = '근무형태 값은 최대 10자입니다.';
    isInvalid = true;
  }

  let salary = jobNoticeDetail.value.salary;

  if (salaryGb === '01') {
    if (!salary) {
      salary = 0;
    }
  } else if (salaryGb !== '01') {
    const salaryNum = Number(salary);
    if (!Number.isInteger(salaryNum) || salaryNum <= 0) {
      inputError.value.salary = '급여를 입력하세요.';
      isInvalid = true;
    } else if (String(salaryNum).length > 6) {
      inputError.value.salary = '급여는 최대 6자리까지 입력 가능합니다.';
      isInvalid = true;
    }
    salary = salaryNum;
  }

  if (!salaryGb || salaryGb.length > 2) {
    inputError.value.salary = '급여구분을 선택하세요.';
    isInvalid = true;
  }

  // if (note && String(note).length > 4000) {
  //   $toast('error', '기타요건은 최대 4000자까지 입력 가능합니다.');
  //   isInvalid = true;
  // }

  // 수정 처리
  if(!isInvalid) {

    loadingStore.loading = true;

    jobFairCorpService.ojfCropJobNoticeUpdate(
        jobNoticeSeqNum, jobNameTrim,
        interests, job, recruitAreaTrim, recruitCntNum,
        jobExperience, schoolGb, specialTreatTrim,
        workArea1Clean, workArea2Clean, workHomeYn, workType,
        salaryGb, salary, note,
    ).then(async (res) => {
      loadingStore.loading = false;

      if (res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;

        // 면접제안 등록
        const ojfCropInterviewProposalCreate = async () => {
          const ok = await $confirm(["채용공고 수정이 완료되었습니다.", "해당 채용공고로 면접제안을 하시겠습니까?"], "면접제안");
          if(!ok) {
            return -1;
          } else {
            let paramObj = {
              ojfId: ojfId,
              resumeId: resumeId,
              jobNoticeSeq: jobNoticeSeq,
            }

            loadingStore.loading = true;
            jobFairCorpService.ojfCropInterviewProposalCreate(paramObj)
                .then( async (res) => {
                  loadingStore.loading = false;
                  if (res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    $alert("면접제안을 하였습니다.");

                    if (mode.value === 'mypage') {
                      router.push({name: 'MyPageCorpJobFairDetail', params:{id: ojfId}})
                    } else if (mode.value === 'openRecruitment') {
                      router.push({name: 'MyPageCorpOpenRecruitmentDetail', params:{id: ojfId}})
                    } else {
                      router.push({name: 'MatchingJobFairDetail', params:{id: ojfId}})
                    }
                  } else {
                    $alert("면접제안을 실패하였습니다.");
                  }
                }).catch( (error) =>  {
              loadingStore.loading = false;
              $alert("제안을 실패하였습니다.");
            });
          }

        }

        if (inteYn === 'N') {
          // inteYn가 'N'이면 면접제안 가능
          // 'Y'면 이미 면접제안이 완료되어 공고 수정만 가능
          await ojfCropInterviewProposalCreate();

        } else {
          if (mode.value === 'admin') { // 어드민에서 사용
            $toast("", "수정되었습니다");
            router.push({name: 'ApprovedJoinStateDetail', params:{id: ojfId}})
          } else {
            $alert("채용공고 수정이 완료되었습니다.");

            if (mode.value === 'mypage') {
              router.push({name: 'MyPageCorpJobFairDetail', params:{id: ojfId}})
            } else if (mode.value === 'openRecruitment' || mode.value === 'mypageOpenRecruitment') {
              router.push({name: 'MyPageCorpOpenRecruitmentDetail', params:{id: ojfId}})
            } else {
              router.push({name: 'MatchingJobFairDetail', params:{id: ojfId}})
            }
          }
        }
      }
    }).catch((error) => {
      loadingStore.loading = false;
      console.log(error);
    });

  } else {
    $toast("error", "올바르게 입력되지 않은 항목이 있습니다.");
    highlightFirstError();
  }

}

const clickCancel = async (ojfId) => {
  $alert("채용공고 수정이 취소되었습니다.");

  if (mode.value === 'mypage') {
    router.push({name: 'MyPageCorpJobFairDetail', params:{id: ojfId}})
  } else if (mode.value === 'openRecruitment') {
    router.push({name: 'MyPageCorpOpenRecruitmentDetail', params:{id: ojfId}})
  } else {
    router.push({name: 'MatchingJobFairDetail', params:{id: ojfId}})
  }
}

// 특수문자 작성 안됨
const filterText = (value) => {
  return value.replace(/[^a-zA-Z0-9ㄱ-ㅎ가-힣\s]/g, ''); // 특수문자 제거
}

const onInputChange = (event, key) => {
  jobNoticeDetail.value[key] = filterText(event.target.value); // 필터링된 값 적용
  if (key === 'jobName') {
    inputError.value.jobName = '' ? '공고 제목을 입력하세요.' : '';
  } else if (key === 'recruitArea') {
    inputError.value.recruitArea = '' ? '모집분야명을 입력하세요.' : '';
  } else if (key === 'specialTreat') {
    inputError.value.specialTreat = '' ? '우대 사항을 입력하세요.' : '';
  }
}

const validateText = (key) => {
  if (key === 'recruitCnt') {
    inputError.value.recruitCnt = '' ? '모집인원을 입력하세요.' : '';
  } else {
    inputError.value.salary = '' ? '급여를 선택하세요.' : '';
  }
}

watch(
    () => jobNoticeDetail.value.schoolGb,
    (newVal) => {
      inputError.value.schoolGb = newVal === '' ? '학력을 선택하세요.' : ''
    }
)

const clearErrorFocus = () => {
  try {
    document.querySelectorAll('.error-focus').forEach(el => el.classList.remove('error-focus'))
  } catch(e){}
}

const focusAndScroll = (el) => {
  if (!el) return
  try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }) } catch(e){}
  try { el.focus && el.focus({ preventScroll: true }) } catch(e){}
  try { el.classList && el.classList.add('error-focus') } catch(e){}
}

const highlightFirstError = () => {
  if (inputError.value.jobName) {
    const el = document.querySelector('.resume-title input')
    focusAndScroll(el)
    return
  }
  if (inputError.value.interests) {
    const el = document.querySelectorAll('.category-wrap')[0]
    focusAndScroll(el)
    return
  }
  if (inputError.value.job) {
    const el = document.querySelectorAll('.category-wrap')[1]
    focusAndScroll(el)
    return
  }
  if (inputError.value.recruitArea) {
    const el = document.querySelector('input[placeholder*="모집분야명"]') || document.querySelector('.table-form .vertical input')
    focusAndScroll(el)
    return
  }
  if (inputError.value.recruitCnt) {
    const el = document.querySelectorAll('.grid.half input')[0]
    focusAndScroll(el)
    return
  }
  if (inputError.value.jobExperience) {
    const el = document.querySelectorAll('.category-wrap')[2]
    focusAndScroll(el)
    return
  }
  if (inputError.value.schoolGb) {
    const el = schoolGbRef.value?.$el || document.querySelector('.table-form .vertical .select')
    focusAndScroll(el)
    return
  }
  if (inputError.value.specialTreat) {
    const el = document.querySelector('input[placeholder*="우대 사항"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.workArea) {
    const el = workAreaRef.value?.$el || document.querySelector('.select')
    focusAndScroll(el)
    return
  }
  if (inputError.value.workType) {
    const el = document.querySelectorAll('.category-wrap')[4]
    focusAndScroll(el)
    return
  }
  if (inputError.value.salary) {
    const el = salaryGbRef.value?.$el || document.querySelectorAll('.grid.half input')[1]
    focusAndScroll(el)
    return
  }
}

</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB class="snb" />
        <div class="content">
          <div class="record-wrap">
            <div class="sub-title">
              <h3>채용공고 수정</h3>
            </div>
            <p class="mt-xs">{{ mode === 'openRecruitment' ? '기업공채관' : '채용박람회' }}에 등록할 채용공고를 작성하세요. (모든 이력사항은 필수 입력사항입니다.)</p>
            <!-- s: 공고 제목 -->
            <div class="content-inner resume-title">
              <KSAInput v-model="jobNoticeDetail.jobName" @input="(event) => onInputChange(event, 'jobName')" maxLength="50" placeholder="공고 제목을 50자 이내로 입력하세요." />
              <p>
                <small style="color:#E71414;">{{ inputError.jobName }}</small>
              </p>
            </div>
            <!-- e: 공고 제목 -->
            <!-- s: 모집 분야 -->
            <div class="table-form">
              <table class="vertical">
                <colgroup>
                  <col width="20%" />
                  <col />
                </colgroup>
                <tr>
                  <th colspan="2">모집 분야</th>
                </tr>
                <tr>
                  <th><span class="mark">관심 카테고리(최대3개)</span></th>
                  <td>
                    <ul class="grid category-wrap">
                      <li :class="{'active': interest.on}" v-for="interest in data_interests" @click="onClickInterest(interest)">
                        {{ interest.label }}
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.interests }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">직무</span></th>
                  <td>
                    <ul class="grid category-wrap">
                      <li :class="{'active': job.on}" v-for="job in data_job" @click="onClickJob(job)">
                        {{ job.label }}
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.job }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">모집분야명</span></th>
                  <td>
                    <KSAInput v-model="jobNoticeDetail.recruitArea" @input="(event) => onInputChange(event, 'recruitArea')" maxLength="50" placeholder="모집분야명을 입력하세요. (ex. 경영지원, 마케팅담당, 운영업무, 등)" />
                    <p>
                      <small style="color:#E71414;">{{ inputError.recruitArea }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">모집인원</span></th>
                  <td>
                    <div class="grid half">
                      <KSAInputNumber v-model="jobNoticeDetail.recruitCnt" @input="validateText('recruitCnt')" placeholder="0" maxLength="3" /> 명
                    </div>
                    <p>
                      <small style="color:#E71414;">{{ inputError.recruitCnt }}</small>
                    </p>
                  </td>
                </tr>
              </table>
            </div>
            <!-- e: 모집 분야 -->
            <!-- s: 지원 자격 / 근무조건 -->
            <div class="table-form mt-xs">
              <table class="vertical">
                <colgroup>
                  <col width="20%" />
                  <col />
                </colgroup>
                <tr>
                  <th colspan="2">지원 자격 / 근무조건</th>
                </tr>
                <tr>
                  <th><span class="mark">경력</span></th>
                  <td>
                    <ul class="grid category-wrap">
                      <li :class="{'active': jobExperience.on}" v-for="jobExperience in data_jobExperience" @click="onClickJobExperience(jobExperience)">
                        {{ jobExperience.label }}
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.jobExperience }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">학력</span></th>
                  <td>
                    <div class="grid half">
                      <KSASelect ref="schoolGbRef" class="select" v-model="jobNoticeDetail.schoolGb" :options="$gb.SCHOOL_GB"/>
                    </div>
                    <p>
                      <small style="color:#E71414;">{{ inputError.schoolGb }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">우대 사항(자격증)</span></th>
                  <td>
                    <KSAInput v-model="jobNoticeDetail.specialTreat" @input="(event) => onInputChange(event, 'specialTreat')" maxLength="50" placeholder="우대 사항을 50자 이내로 입력하세요." />
                    <p>
                      <small style="color:#E71414;">{{ inputError.specialTreat }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">근무지역</span></th>
                  <td>
                    <KSASelectResidenceArea
                        class="select"
                        ref="workAreaRef"
                        @selectOption1="onSelectedWorkArea1"
                        @selectOption2="onSelectedWorkArea2"
                    />
                    <ul class="grid category-wrap">
                      <li :class="{'active': jobNoticeDetail.workHomeYn === 'Y'}" @click="onClickWorkHomeYn(jobNoticeDetail.workHomeYn)">
                        재택근무 가능
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.workArea }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">근무형태</span></th>
                  <td>
                    <ul class="grid category-wrap">
                      <li :class="{'active': workType.on}" v-for="workType in data_workType" @click="onClickWorkType(workType)">
                        {{ workType.label }}
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.workType }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">급여</span></th>
                  <td>
                    <div class="grid half">
                      <div class="mr-xs select-min">
                        <KSASelect ref="salaryGbRef" class="select" v-model="jobNoticeDetail.salaryGb" :options="$gb.SALARY_GB"/>
                      </div>
                      <KSAInputNumber ref="salaryRef" v-model="jobNoticeDetail.salary" :disabled="jobNoticeDetail.salaryGb === '01'" @input="validateText('salary')" maxLength="6" placeholder="0"/>
                      <span class="ml-xs">만원</span>
                    </div>
                    <p>
                      <small style="color:#E71414;">{{ inputError.salary }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>기타 요건</th>
                  <td>
                    <KSACKEditor ref="editorRef" v-model="jobNoticeDetail.note" container="public"/>
                    <!-- <span :style="{ display: 'flex', justifyContent: 'flex-end', color: (jobNoticeDetail.note && jobNoticeDetail.note.length > 4000) ? 'red' : '' }">{{jobNoticeDetail.note.length}}/4,000자</span> -->
                  </td>
                </tr>
              </table>
            </div>
            <!-- e: 지원 자격 / 근무조건 -->
          </div>
        </div>
      </div>
    </div>
    <div class="btn-wrap bottom-btn text-right">
      <div class="inner">
        <div class="flex-wrap">
          <KSASecondaryButton class="gray_button" text="취소" @click="clickCancel(jobNoticeDetail.ojfId)" />
          <div>
            <KSAPrimaryButton text="수정 완료" @click="updateJobNotice(jobNoticeSeq, jobNoticeDetail.ojfId, resumeId, inteYn)" :disabled="saveIsDisabled"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

@import "../../../../../assets/scss/theme";

hr {
  border: 0;
  height: 1px;
  background-color: $gray-regular_color;
  margin: 40px 0;
}

.select-min {
  .select-wrap {
    width: 30%;
  }
}

.container {
  padding-bottom: 0;
  .content {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    .record-wrap {
      width: 100%;
      margin-right: 0;
      .resume-title {
        padding: 20px 0;
      }
      .table-form {
        table {
          th {
            text-align: left;
          }
        }
      }
    }
  }
  .btn-wrap {
    .inner {
      width: calc(100% - 352px);
      margin: auto;
      padding: 0;
    }
    .flex-wrap {
      justify-content: space-between;
    }
  }
}

:deep(.error-focus),
:deep(.error-focus input) {
  outline: 2px solid #E71414 !important;
  border-color: #E71414 !important;
}

</style>